//#region src/tools/types.ts
/**
* Resolves a tool description to a string.
* Handles both static strings and dynamic description functions.
*/
function resolveDescription(description, context) {
	return typeof description === "function" ? description(context) : description;
}
/**
* Determines if a tool is enabled for the current release mode.
*/
function isToolVisibleInMode(tool, experimentalMode) {
	if (tool.experimental && !experimentalMode) return false;
	if (tool.hideInExperimentalMode && experimentalMode) return false;
	return true;
}

//#endregion
export { isToolVisibleInMode, resolveDescription };
//# sourceMappingURL=types-DGnYE-i7.js.map